// Players on an open tab move to a new deploy by themselves (owner 2026-10-29): no lost progress, the
// reload waits until nobody is looking, and afterwards they see what they saw. Pure rules (node --test);
// ui/autoUpdate.js wires them. Every action is saved on the server as it happens and the scene +
// position come back from the saved location (BootScene); only a visit needs remembering here.

export const SNAPSHOT_KEY = 'sd_reload_visit';
export const TRIED_KEY = 'sd_reloaded_for';            // the stamp we already reloaded for (no reload loop)
export const SNAPSHOT_MAX_AGE_MS = 10 * 60_000;

// `current` is this page's build stamp (ASSET_VERSION, the git sha in prod), `remote` the one in
// /version.json (null when it could not be read), `tried` the stamp a reload already went for.
export function isNewVersion(current, remote, tried = null) {
  return !!remote && current !== 'dev' && remote !== 'dev' && remote !== current && remote !== tried;
}

// Tab hidden, a Zzz or Przerwa — and no save, ride, match or open panel under way.
export function reloadAllowed({ pending, hidden, stage, busy }) {
  return !!pending && !busy && (hidden || stage !== 'awake');
}

export function visitSnapshot({ scene, hostId, hostName = '', x = null, y = null }, nowMs) {
  if (!scene || !hostId) return null;
  return JSON.stringify({ scene, hostId, hostName, x: x == null ? null : Math.round(x), y: y == null ? null : Math.round(y), at: nowMs });
}

// → { scene, data } to start, or null (missing, unreadable, stale, or a scene this build lacks).
export function readVisitSnapshot(json, nowMs, visitScenes) {
  let s;
  try { s = JSON.parse(json); } catch { return null; }
  if (!s || !s.hostId || !visitScenes.has(s.scene) || !(nowMs - s.at <= SNAPSHOT_MAX_AGE_MS)) return null;
  const data = { hostId: s.hostId, hostName: s.hostName ?? '' };
  if (s.x != null && s.y != null) Object.assign(data, { spawnX: s.x, spawnY: s.y });
  return { scene: s.scene, data };
}
